import actionTypes from '../actions/action-types';

const unreadMessageCount = ({ messages, selectedMessagesList }, isReadStatus) => {
  return messages.filter((message) => {
    const isIncluded = selectedMessagesList.includes(message.userMessageId);

    return isIncluded && message.isRead === isReadStatus;
  }).length;
};

export default (state = 0, action) => {
  switch (action.type) {
    case actionTypes.FETCH_UNREAD_MESSAGES_COUNT_SUCCESS: {
      return action.count;
    }
    case actionTypes.MARK_MESSAGE_AS_READ_SUCCESS:
    case actionTypes.DELETE_MESSAGES_SUCCESS: {
      return state - unreadMessageCount(action, false);
    }
    case actionTypes.MARK_MESSAGE_AS_UNREAD_SUCCESS: {
      return state + unreadMessageCount(action, true);
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/reducers/unread-count.js